import { createStore, applyMiddleware  } from "redux";
import { routerMiddleware } from "react-router-redux";
import { composeWithDevTools } from 'redux-devtools-extension';
import Logger from "redux-logger";
import thunk from 'redux-thunk';
import createHistory from "history/createBrowserHistory";

import * as fromAppsStoreCombines  from "@apps-store/reducers";

const history = createHistory();

const composeEnhancers = composeWithDevTools({});



export const StoreOfApp = createStore<any , any, {}, {}>(
    
    fromAppsStoreCombines.fromCombineReducer, 
    composeEnhancers(
        applyMiddleware(
            routerMiddleware(history),
            Logger, 
            thunk
        )
    )
    
);




// WEBPACK FOOTER //
// ./src/root/store/index.ts